<template>
  <div class="button-menu-wrapper">
    <span class="new-item" v-if="isNew">new</span>
    <div class="button-menu button-menu-filter stop-event">
      <div class="button-menu-filter-wrapper">
        <span class="button-menu-filter-icon" :class="filter" :style="iconClass" v-if="iconClass"/>
        <span class="button-menu-filter-label" v-if="label">{{label}}</span>
      </div>
    </div>
    <sw-icon font="fa" icon="lock" v-if="locked" class="locked"/>
  </div>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////

//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'ButtonFilterMenu',
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {}
  },
  props: {
    iconClass: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    filter: {
      type: String
    },
    isNew: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/buttons/ButtonFilterMenu.vue